import { authTypes } from '../auth/types'
import { InspectionReportDetail, InspectionReportsResponse } from '../types'
import {
    InspectionReportsActions,
    InspectionReportsType,
    inspectionReportsTypes
} from './types'

const initialState: InspectionReportsType = {
  inspectionReports: null,
  inspectionReportData: null,
}
const reducer = (
  state = initialState,
  action: InspectionReportsActions
): InspectionReportsType => {
  const { type, payload } = action

  switch (type) {
    case authTypes.LOGIN_REQUEST: { return initialState }
    case authTypes.LOGOUT_REQUEST: { return initialState }

    case inspectionReportsTypes.SET_INSPECTION_REPORTS: {
      return {
        ...state,
        inspectionReports: payload as InspectionReportsResponse,
      }
    }

    case inspectionReportsTypes.SET_INSPECTION_REPORT_BY_ID: {
      return {
        ...state,
        inspectionReportData: payload as InspectionReportDetail,
      }
    }

    default:
      return state
  }
}

export default reducer
